import React, { useState } from "react";
import { MdExpandMore, MdExpandLess, MdEdit, MdDownload, MdHistory, MdDelete } from "react-icons/md";

const BaselineRecord = ({ bl, idx, totalCount, onDownloadPDF, onRename, onDelete }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isRenaming, setIsRenaming] = useState(false);
  const [tempName, setTempName] = useState(bl.currentName || bl.originalName || bl.dateRange || "");
  const [showAudit, setShowAudit] = useState(false);
  const [renamingLoading, setRenamingLoading] = useState(false);

  const handleSaveRename = async (e) => {
    e.stopPropagation();
    if (!tempName.trim()) return;
    try {
      setRenamingLoading(true);
      const res = await onRename(bl._id, tempName.trim());
      if (res?.success) {
        setIsRenaming(false);
      } else {
        alert(res?.message || "Failed to rename frozen record");
      }
    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setRenamingLoading(false);
    }
  };

  const selectedDaysCount = bl.tableRows && bl.tableRows.length > 0
    ? bl.tableRows.filter(r => !r.isDeselected && (!r.record || r.record.dayInclude !== 'no')).length
    : null;

  return (
    <div style={{
      padding: '20px',
      background: idx === 0 ? '#f1f5f9' : '#fff',
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      position: 'relative'
    }}>
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isOpen ? '15px' : '0', cursor: 'pointer', flexWrap: 'wrap', gap: '10px' }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>

          {isOpen ? <MdExpandLess size={20} color="#64748b" /> : <MdExpandMore size={20} color="#64748b" />}
          <div style={{ fontWeight: '700', color: '#2563eb', fontSize: '0.95rem' }}>
            {" Frozen Record (" + (selectedDaysCount || 0) + " days)"}
          </div>
          <span style={{ color: '#cbd5e1' }}>|</span>

          {isRenaming ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }} onClick={(e) => e.stopPropagation()}>
              <input
                type="text"
                value={tempName}
                onChange={(e) => setTempName(e.target.value)}
                style={{
                  padding: '4px 8px',
                  fontSize: '0.85rem',
                  borderRadius: '4px',
                  border: '1px solid #cbd5e1',
                  outline: 'none',
                  minWidth: '180px'
                }}
                disabled={renamingLoading}
                autoFocus
              />
              <button
                onClick={handleSaveRename}
                disabled={renamingLoading || !tempName.trim()}
                style={{
                  background: '#10b981',
                  color: '#fff',
                  border: 'none',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '0.8rem',
                  fontWeight: 600
                }}
              >
                {renamingLoading ? "Saving..." : "Save"}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIsRenaming(false);
                  setTempName(bl.currentName || bl.originalName || "");
                }}
                disabled={renamingLoading}
                style={{
                  background: '#64748b',
                  color: '#fff',
                  border: 'none',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '0.8rem',
                  fontWeight: 600
                }}
              >
                Cancel
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontWeight: '600', color: '#1e293b', fontSize: '0.95rem' }}>
                {bl.currentName || bl.originalName || bl.dateRange}
              </span>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setIsRenaming(true);
                }}
                style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', padding: '2px' }}
                title="Rename record"
              >
                <MdEdit size={16} color="#64748b" />
              </span>
            </div>
          )}

        </div>
        <div style={{ fontSize: '0.85rem', color: '#64748b' }}>
          Saved on: <strong>{new Date(bl.savedAt).toLocaleDateString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</strong>
        </div>
      </div>

      {isOpen && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '15px', marginBottom: '15px' }}>
            <div style={{ background: idx === 0 ? '#fff' : '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '2px' }}>Date Range</div>
              <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '0.9rem' }}>{bl.dateRange}</div>
            </div>
            <div style={{ background: idx === 0 ? '#fff' : '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '2px' }}>Voids</div>
              <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '1.1rem' }}>{bl.voids}</div>
            </div>
            <div style={{ background: idx === 0 ? '#fff' : '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '2px' }}>Leaks</div>
              <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '1.1rem' }}>{bl.leaks}</div>
            </div>
            <div style={{ background: idx === 0 ? '#fff' : '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '2px' }}>Fluids (oz)</div>
              <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '1.1rem' }}>{bl.fluid}</div>
            </div>
            {/* <div style={{ background: idx === 0 ? '#fff' : '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '2px' }}>Night Voids</div>
              <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '1.1rem' }}>{bl.night}</div>
            </div> */}
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
            paddingTop: '10px',
            borderTop: '1px solid #e2e8f0'
          }}>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
              {bl.study && (
                <span style={{ fontSize: '0.8rem', color: '#64748b' }}>
                  Study: <strong style={{ color: '#475569' }}>{bl.study}</strong> {bl.site && <>| Site: <strong style={{ color: '#475569' }}>{bl.site}</strong></>}
                </span>
              )}
              {bl.adminName && (
                <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>
                  Saved by: {bl.adminName}
                </span>
              )}
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              {onDownloadPDF && (
                <button
                  onClick={() => onDownloadPDF(bl)}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    background: '#2563eb',
                    color: '#fff',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  title="Download Records"
                >
                  <MdDownload size={14} /> Download Records
                </button>
              )}
              {bl.auditTrail && bl.auditTrail.length > 0 && (
                <button
                  onClick={() => setShowAudit(!showAudit)}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    background: '#f8fafc',
                    color: '#475569',
                    border: '1px solid #cbd5e1',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                >
                  <MdHistory size={14} /> {showAudit ? "Hide Audit" : "Audit Trail"}
                </button>
              )}
              {onDelete && (
                <button
                  onClick={() => onDelete(bl._id)}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    background: '#fef2f2',
                    color: '#dc2626',
                    border: '1px solid #fecaca',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  title="Delete frozen record (Admin only)"
                  onMouseEnter={e => { e.currentTarget.style.background = '#dc2626'; e.currentTarget.style.color = '#fff'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#fef2f2'; e.currentTarget.style.color = '#dc2626'; }}
                >
                  <MdDelete size={14} /> Delete
                </button>
              )}
            </div>
          </div>

          {showAudit && bl.auditTrail && bl.auditTrail.length > 0 && (
            <div style={{
              marginTop: '15px',
              padding: '12px',
              background: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              fontSize: '0.85rem',
              color: '#475569'
            }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: '#1e293b' }}>Audit Trail Logs:</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {bl.auditTrail.map((log, li) => (
                  <div key={li} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    borderBottom: li < bl.auditTrail.length - 1 ? '1px dashed #e2e8f0' : 'none',
                    paddingBottom: '6px',
                    gap: '10px'
                  }}>
                    <div>
                      <strong>{log.action}</strong>: {log.action === "RENAME" ? (
                        <>Renamed from <em>"{log.previousName}"</em> to <em>"{log.newName}"</em></>
                      ) : (
                        <>Frozen PDF record created as <em>"{log.newName}"</em></>
                      )}
                    </div>
                    <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                      By {log.changedBy || "Admin"} ({log.changedByEmail || "N/A"}) on {new Date(log.changedAt).toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export const BaselineSection = ({ baselines, showBaselineHistory, setShowBaselineHistory, onDownloadPDF, onDownloadAveragesPDF, onRename, onDelete }) => {
  const hasBaselines = baselines && baselines.length > 0;

  return (
    <div style={{ marginTop: '40px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
          cursor: 'pointer',
          userSelect: 'none'
        }}
        onClick={() => setShowBaselineHistory(!showBaselineHistory)}
      >
        {showBaselineHistory ? <MdExpandLess size={24} color="#64748b" /> : <MdExpandMore size={24} color="#64748b" />}
        <h3 style={{ margin: 0, color: '#1e293b', fontSize: '1.25rem', fontWeight: '600' }}>Patient Frozen Records History</h3>
      </div>

      {showBaselineHistory && (
        <>
          {hasBaselines ? (
            <>
              <div style={{
                background: '#f8fafc',
                padding: '16px',
                borderRadius: '8px',
                marginBottom: '20px',
                display: 'flex',
                border: '1px solid #e2e8f0',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '24px',
                flexWrap: 'wrap'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
                  <div style={{ fontWeight: 600, color: '#475569' }}>Total Frozen Record Averages:</div>
                  {(() => {
                    const count = baselines.length;
                    const avg = {
                      voids: (baselines.reduce((acc, curr) => acc + Number(curr.voids || 0), 0) / count).toFixed(1),
                      leaks: (baselines.reduce((acc, curr) => acc + Number(curr.leaks || 0), 0) / count).toFixed(1),
                      fluid: (baselines.reduce((acc, curr) => acc + Number(curr.fluid || 0), 0) / count).toFixed(1),
                      night: (baselines.reduce((acc, curr) => acc + Number(curr.night || 0), 0) / count).toFixed(1)
                    };
                    return (
                      <>
                        <div style={{ fontSize: '0.9rem' }}>Voids: <strong>{avg.voids}</strong></div>
                        <div style={{ fontSize: '0.9rem' }}>Leaks: <strong>{avg.leaks}</strong></div>
                        <div style={{ fontSize: '0.9rem' }}>Fluids (oz): <strong>{avg.fluid}</strong></div>
                        {/* <div style={{ fontSize: '0.9rem' }}>Night Voids: <strong>{avg.night}</strong></div> */}
                      </>
                    );
                  })()}
                </div>
                {onDownloadAveragesPDF && (
                  <button
                    onClick={onDownloadAveragesPDF}
                    style={{
                      background: '#2563eb',
                      color: '#fff',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      transition: 'background 0.2s'
                    }}
                    title="Download Averages PDF"
                  >
                    <MdDownload size={16} /> Download Total Records
                  </button>
                )}
              </div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                maxHeight: '600px',
                overflowY: 'auto',
                paddingRight: '10px'
              }}>
                {baselines.map((bl, idx) => (
                  <BaselineRecord
                    key={bl._id || idx}
                    bl={bl}
                    idx={idx}
                    totalCount={baselines.length}
                    onDownloadPDF={onDownloadPDF}
                    onRename={onRename}
                    onDelete={onDelete}
                  />
                ))}
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '30px', background: '#f8fafc', borderRadius: '8px', color: '#64748b', border: '1px dashed #cbd5e1' }}>
              No frozen record history found for this patient.
            </div>
          )}
        </>
      )}
    </div>
  );
};
